import { afterNextRender, Directive, ElementRef, Renderer2, inject, input } from '@angular/core';

@Directive({
    selector: '[tranSkipTab]'
})
export class SkipTabDirective {
    /**
     * CSS selector of the element that should be removed from tab order.
     *
     * Example:
     * <si-number-input tranSkipTab="input" />
     */
    public readonly tranSkipTab = input<string>('input');

    private readonly host = inject<ElementRef<HTMLElement>>(ElementRef);
    private readonly renderer = inject(Renderer2);

    constructor() {
        afterNextRender(() => {
            const target = this.host.nativeElement.querySelector<HTMLElement>(this.tranSkipTab());

            if (target) {
                this.renderer.setAttribute(target, 'tabindex', '-1');
            }
        });
    }
}
